import * as Sentry from '@sentry/react';
import { Routes, Route } from 'react-router-dom';

import { AnnotationToolUiRoutes } from '@verantos-dev/annotation-tool-ui-routes';
import { ENTERPRISE_LOGIN_LOGOUT_PATH } from '@verantos-dev/core-annotation-tool';
import { LogoutPage } from '@verantos-dev/el-feature-logout-page';

import { AnnotationToolAppPageLayoutContainer } from '../components/AnnotationToolAppPageLayoutContainer';
import { AnnotationToolLandingPage } from '../components/AnnotationToolLandingPage';
import ScrollToTop from '../components/ScrollToTop';
import { useSentry } from '../hooks/useSentry';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function App() {
  useSentry();
  return (
    <>
      <ScrollToTop />
      <SentryRoutes>
        <Route path={ENTERPRISE_LOGIN_LOGOUT_PATH} element={<LogoutPage />} />
        <Route path="*" element={<AnnotationToolAppPageLayoutContainer />}>
          <Route index element={<AnnotationToolLandingPage />} />
          <Route path="*" element={<AnnotationToolUiRoutes />} />
        </Route>
      </SentryRoutes>
    </>
  );
}
